import React from "react"
import { AvField } from "availity-reactstrap-validation"
import { getCurrentUser } from "../../../helpers/Utils"

const SendMethodSelector = ({
  lead,
  className = "",
  emailLabel = "Email",
  whatsappLabel = "Whatsapp",
  showSendLabel = true,
}) => {
  const dynamicClassName =
    (lead && lead.leadholder_role == null) ||
    (lead && lead.leadholder_role == "Administrator")
      ? "mb-3"
      : "mb-3 ms-5"

  const finalClassName = className || dynamicClassName

  return (
    <div className={finalClassName}>
      {showSendLabel && <label>Send</label>}
      <div className="d-flex">
        <div className="mb-3 me-2">
          <AvField
            label={emailLabel}
            type="checkbox"
            name="send_email"
            style={{
              background: `${
                getCurrentUser()?.email_enabled === 1 ? "" : "lightgray"
              }`,
            }}
            disabled={getCurrentUser()?.email_enabled === 1 ? false : true}
          />
        </div>
        <div className="mb-3 ms-4">
          <AvField
            label={whatsappLabel}
            type="checkbox"
            name="whatsapp"
            style={{
              background: `${
                getCurrentUser()?.whatsapp_enabled === 1 ? "" : "lightgray"
              }`,
            }}
            disabled={getCurrentUser()?.whatsapp_enabled === 1 ? false : true}
          />
        </div>
      </div>
    </div>
  )
}

export default SendMethodSelector
